"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateInputForAttribute = exports.getValues = exports.countDecimals = exports.sortByKey = exports.filterArray = exports.isEmptyArray = exports.transformInputs = exports.getCountryName = exports.makeCancelable = exports.getRuleSet = exports.getInputs = exports.request = exports.capitalize = void 0;

var _i18nIsoCountries = _interopRequireDefault(require("i18n-iso-countries"));

var _map = _interopRequireDefault(require("lodash/map"));

var _constants = _interopRequireDefault(require("./constants"));

_i18nIsoCountries["default"].registerLocale(require('i18n-iso-countries/langs/en.json'));

function checkResponse(res) {
  if (res.ok) {
    return res.json();
  }

  return null;
}

function makeRequestHeader(accessToken) {
  return {
    Accept: 'application/json',
    Authorization: "Bearer ".concat(accessToken),
    'Content-Type': 'application/json'
  };
}

var capitalize = function capitalize(str) {
  if (str && typeof str === 'string' && str.length > 1) return str.charAt(0).toUpperCase() + str.slice(1);
  return str;
};

exports.capitalize = capitalize;

var request = function request(url, accessToken) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
  var body = arguments.length > 3 ? arguments[3] : undefined;
  var options = {
    headers: makeRequestHeader(accessToken),
    method: method,
    mode: 'cors'
  };

  if (method !== 'GET') {
    options.body = body;
  }

  return fetch(url, options).then(function (res) {
    return checkResponse(res);
  }).then(function (res) {
    return res;
  });
};

exports.request = request;

var getInputs = function getInputs(sku, accessToken) {
  return request("".concat(_constants["default"].REQUIRED_INPUTS_URL, "/").concat(sku), accessToken);
};

exports.getInputs = getInputs;

var getRuleSet = function getRuleSet(referenceId, accessToken) {
  return request("".concat(_constants["default"].REFERENCEID_RULESET_URL, "?referenceId=").concat(referenceId), accessToken);
};

exports.getRuleSet = getRuleSet;

var makeCancelable = function makeCancelable(promise) {
  var cancelled = false;
  var cancelablePromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return cancelled ? reject({
        isCanceled: true
      }) : resolve(val);
    }, function (error) {
      return cancelled ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return {
    promise: cancelablePromise,
    cancel: function cancel() {
      cancelled = true;
    }
  };
};

exports.makeCancelable = makeCancelable;

var getCountryName = function getCountryName(attributeValue) {
  return "".concat(_i18nIsoCountries["default"].getName(attributeValue, 'en'), " (").concat(attributeValue, ")");
};

exports.getCountryName = getCountryName;

var transformInputs = function transformInputs(attributeValues) {
  return (0, _map["default"])(attributeValues, function (attributeValue) {
    return {
      key: attributeValue.value,
      value: getCountryName(attributeValue.value)
    };
  }).sort(function (a, b) {
    if (a.value > b.value) {
      return 1;
    }

    return -1;
  });
};

exports.transformInputs = transformInputs;

var isEmptyArray = function isEmptyArray(array) {
  return !(array && array.length);
};

exports.isEmptyArray = isEmptyArray;

var filterArray = function filterArray(parentArray, childArray) {
  return !isEmptyArray(parentArray) && !isEmptyArray(childArray) ? parentArray.filter(function (value) {
    return childArray.indexOf(value) < 0;
  }) : parentArray;
};

exports.filterArray = filterArray;

var sortByKey = function sortByKey(array, key) {
  return array.sort(function (a, b) {
    var x = key ? a[key] : a;
    var y = key ? b[key] : b;
    if (x < y) return -1;
    if (x > y) return 1;
    return 0;
  });
};

exports.sortByKey = sortByKey;

var countDecimals = function countDecimals(num) {
  return num && Math.floor(num) !== num ? num.toString().split('.')[1].length || 0 : 0;
};

exports.countDecimals = countDecimals;

var getValues = function getValues(attribute) {
  return attribute && (attribute.selectedValues || attribute.defaults || attribute.values);
};

exports.getValues = getValues;

var validateInputForAttribute = function validateInputForAttribute(value, attribute) {
  if (attribute) {
    if (attribute.isRange) {
      var _attribute$values = attribute.values,
          ranges = _attribute$values.ranges,
          fixedValues = _attribute$values.fixedValues;
      var isFixedValue = fixedValues ? fixedValues.indexOf(value) > -1 : false;
      var isWithinRange = false;

      for (var i = 0; i < ranges.length; i += 1) {
        var _ranges$i = ranges[i],
            minimum = _ranges$i.minimum,
            increment = _ranges$i.increment;
        var maximum = ranges[i].maximum;
        maximum = maximum === 'infinity' ? Number.MAX_SAFE_INTEGER : maximum;
        var incrementDecimalCount = countDecimals(increment);
        var multiplier = Math.pow(10, incrementDecimalCount);

        if (value >= minimum && value <= maximum) {
          var remainder = (value * multiplier - minimum * multiplier) / increment * multiplier;
          isWithinRange = Math.round(remainder) - remainder === 0;
        }

        if (isWithinRange) {
          break;
        }
      }

      return isFixedValue || isWithinRange;
    }

    return attribute.values && attribute.values.includes(value);
  }

  return null;
};

exports.validateInputForAttribute = validateInputForAttribute;